import { Router } from '@funtech-int/rival';

interface Params {
    router: Router;
    queryParams: Record<string, string>;
}

export const setQueryParams = ({ router, queryParams }: Params) => {
    const searchParams = new URLSearchParams(window.location.search);

    Object.entries(queryParams).forEach(([key, value]) => {
        searchParams.set(key, value);
    });

    router.navigate({
        to: router.location,
        replace: true,
        meta: {
            searchParams,
        },
    });
};
